import I18n from 'i18n'
import uniq from 'lodash/uniq'
import { CALL_API, REQUEST_POST } from '../middleware/api'
import { ERROR, SUCCESS } from '../components/AlertListItem'
import { clips as clipsAPI } from '../utils/api'
import { buildBaseURL } from '../utils/urlHelper'
import { camelizeKeys } from 'humps'
import { createAlert } from './alertActions'
import { normalize } from 'normalizr'
import { CLIP, NONE } from '../schemas'

export const ADD_CLIP_TO_WORKSPACE_REQUEST = 'tru/ADD_CLIP_TO_WORKSPACE_REQUEST'
export const ADD_CLIP_TO_WORKSPACE_SUCCESS = 'tru/ADD_CLIP_TO_WORKSPACE_SUCCESS'
export const ADD_CLIP_TO_WORKSPACE_FAILURE = 'tru/ADD_CLIP_TO_WORKSPACE_FAILURE'
export const DOWNLOAD_CLIP_REQUEST = 'tru/DOWNLOAD_CLIP_REQUEST'
export const DOWNLOAD_CLIP_SUCCESS = 'tru/DOWNLOAD_CLIP_SUCCESS'
export const DOWNLOAD_CLIP_FAILURE = 'tru/DOWNLOAD_CLIP_FAILURE'
export const FETCH_CLIP_REQUEST = 'tru/FETCH_CLIP_REQUEST'
export const FETCH_CLIP_SUCCESS = 'tru/FETCH_CLIP_SUCCESS'
export const FETCH_CLIP_FAILURE = 'tru/FETCH_CLIP_FAILURE'

const requestClip = id => ({
  type: FETCH_CLIP_REQUEST,
  id
})

const receiveClip = (data, { entities }) => ({
  type: FETCH_CLIP_SUCCESS,
  data,
  entities
})

const receiveClipFailed = errors => ({
  type: FETCH_CLIP_FAILURE,
  errors
})

export const fetchClip = id => dispatch => {
  dispatch(requestClip(id))

  return clipsAPI
    .get(id)
    .then(
      ({ data }) =>
        dispatch(receiveClip(camelizeKeys(data), normalize(data, CLIP))),
      error => dispatch(receiveClipFailed(error))
    )
}

const requestDownloadClip = () => ({ type: DOWNLOAD_CLIP_REQUEST })
const downloadClipSucceeded = () => ({ type: DOWNLOAD_CLIP_SUCCESS })
const downloadClipFailed = () => ({ type: DOWNLOAD_CLIP_FAILURE })

export const downloadClip = id => dispatch => {
  dispatch(requestDownloadClip())

  return clipsAPI.downloadVideoClip(id).then(
    () => {
      dispatch(downloadClipSucceeded())
      dispatch(
        createAlert({
          type: SUCCESS,
          message:
            // eslint-disable-next-line
            I18n.t(
              'Successfully added your download to the queue. You can download it by navigating to the '
            ) +
            '<a href="/r/downloads">' +
            I18n.t('downloads page') +
            '</a>',
          htmlSafe: true
        })
      )
    },
    () => {
      dispatch(downloadClipFailed())
      dispatch(
        createAlert({
          type: ERROR,
          message:
            'There was a problem adding your download to the queue. ' +
            'Please try again'
        })
      )
    }
  )
}

export const addToWorkspace = (company, clip, workspace) => {
  const workspaceURL = buildBaseURL(`workspaces/${workspace.id}`)

  return {
    [ADD_CLIP_TO_WORKSPACE_SUCCESS]: {
      entities: {
        clips: {
          [clip.id]: {
            workspaces: uniq([
              ...clip.workspaces.map(workspace => workspace.id),
              workspace.id
            ])
          }
        }
      },
      alert: {
        type: SUCCESS,
        message: `Added to ${workspace.name}. \
          <a href="${workspaceURL}">View it now!</a>`,
        htmlSafe: true
      }
    },
    [CALL_API]: {
      types: [
        ADD_CLIP_TO_WORKSPACE_REQUEST,
        ADD_CLIP_TO_WORKSPACE_SUCCESS,
        ADD_CLIP_TO_WORKSPACE_FAILURE
      ],
      // eslint-disable-next-line max-len
      endpoint: `companies/${company.id}/workspaces/${workspace.id}/clips/${clip.id}.json`,
      requestType: REQUEST_POST,
      schema: NONE
    }
  }
}



// WEBPACK FOOTER //
// ../src/actions/ClipActions.js